import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { compareToReference, formatComparatorPhrase, isFiniteNumber } from './narrativeFormatting';

const CHART_ID = 'commute_time_extreme';
const VIEW_ID = 'default';

export interface CommuteTimeNarrativeInput {
  locationName: string;
  latestYear: number | null;
  medianMinutes: number | null;
  californiaMedian: number | null;
  extremeCommutePct: number | null;
}

export function buildCommuteTimeExtremeAuthoredBundle(input: CommuteTimeNarrativeInput) {
  const comparisonSentence =
    isFiniteNumber(input.medianMinutes) && isFiniteNumber(input.californiaMedian)
      ? ` ${formatComparatorPhrase(
          compareToReference(input.medianMinutes, input.californiaMedian).relation,
          'California'
        )} California’s median of ${input.californiaMedian.toFixed(1)} minutes.`
      : '';
  const tokens = {
    locationName: input.locationName,
    latestYear: input.latestYear,
    commuteMetricValue: input.medianMinutes != null ? input.medianMinutes.toFixed(1) : null,
    commuteMetricLabel:
      'estimated median one-way commute time to work from the binned ACS distribution',
    unit: 'minutes',
    trendSentence: '',
    comparisonSentence,
    extremeCommuteShare:
      input.extremeCommutePct != null ? Number(input.extremeCommutePct.toFixed(1)) : null,
  };
  return renderAuthoredNarrativeBundle(CHART_ID, VIEW_ID, tokens);
}

export function commuteTimeExtremeOverviewDescription(): string {
  return getAuthoredOverview(
    CHART_ID,
    VIEW_ID,
    'ACS commute duration and share of workers with 90+ minute one-way commutes.'
  );
}

export function buildCommuteTimeExtremeKeyInsights(input: CommuteTimeNarrativeInput): string {
  const bundle = buildCommuteTimeExtremeAuthoredBundle(input);
  return bundle.keyInsights || `Commute time data are not available for ${input.locationName}.`;
}
